import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import QuestionBooksContent from './components/QuestionBooksContent'
import Sidebar from '../../components/SideBar'

const Cadernos: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <QuestionBooksContent />
      <Footer />
    </>
  )
}

export default Cadernos
